export const nop = () => void 0;